export const EDITO_WIDGET_X_PADDING = 'px-4 2xl:px-0';
